import '@unocss/reset/tailwind.css'
import 'uno.css'
import { defineNuxtPlugin } from '#imports'; export default defineNuxtPlugin(() => {})